export const SECTIONS: Array<{ id: string; label: string }> = [
  { id: "INDEX", label: "Index" },
  { id: "HERO", label: "Hero" },
  { id: "ABOUT", label: "About" },
  { id: "HOW_IT_WORKS", label: "How It Works" },
  { id: "AUTOMATION_AGENTS", label: "Agents" },
  { id: "AUTOMATION_RULES", label: "Rules" },
  { id: "AUTOMATION_TASKS", label: "Tasks" },
  { id: "ENTERPRISE_READY", label: "Enterprise Ready" },
  { id: "INTEGRATIONS", label: "Integrations" },
  { id: "ITERATION", label: "Iteration" },
];

export const HOME_SECTIONS: Array<{ id: string; label: string }> = [
  { id: "HERO", label: "Hero" },
  { id: "ABOUT", label: "About" },
  { id: "HOW_IT_WORKS", label: "How It Works" },
  // { id: "AUTOMATION_AGENTS", label: "Agents" },
  // { id: "AUTOMATION_RULES", label: "Rules" },
  // { id: "AUTOMATION_TASKS", label: "Tasks" },
  { id: "ENTERPRISE_READY", label: "Enterprise Ready" },
  // { id: "INTEGRATIONS", label: "Integrations" },
  { id: "ITERATION", label: "Iteration" },
];
